export enum FormStatus {
  ERROR = "ERROR",
  TOUCHED = "TOUCHED",
  UNTOUCHED = "UNTOUCHED",
}
